/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-08 13:49:18
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title6 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P6 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      tableColumns: [],
      tableList: [],
    }
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          // width: index > 0 ? 80: 'auto',
          height: 22,
          fontSize: 12,
          textAlign: 'center',
          fontWeight: 'normal',
          color: '#000',
          background: '#fff',
          border,
        },
        colStyle: (val, r, i) => {
          return {
            height: 22,
            fontSize: 12,
            textAlign: i > 0 ? 'center' : 'right',
            fontWeight: 'normal',
            background: '#fff',
            border,
          }
        },
        render: (val, record, i, index) => {
          if (index > 0) {
            return <span className={s.block} style={{ background: val }} />
          }
          return val;
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, chartColorList, tableColumns, tableList } = this.state;
    return (
      <Stage>
        <Title6 pageNumber="01">
          小罐茶现状认知-品牌方向
        </Title6>

        <div className={s.content}>
          <ul className={s.desContent}>
            <li contentEditable>
              2021年，小罐茶在创始人品牌、公司品牌和产品品牌这三个方向中，
              <span className={s.emphasis}>产品品牌</span>的内容条数最高，为<span className={s.emphasis}>39,860</span>条；
              其次为<span className={s.emphasis}>创始人品牌</span>，内容条数为<span className={s.emphasis}>2,543</span>条；
              <span className={s.emphasis}>公司品牌</span>的内容条数最低，为<span className={s.emphasis}>1,021</span>条。
            </li>
            <li contentEditable>
              这三个品牌方向中，数字品牌价值占比最高的情感倾向等级均为“<span className={s.emphasis}>推荐类</span>”；
              公司品牌和产品品牌的负面内容较少。
            </li>
            <li contentEditable>
              创始人品牌相关内容中，口碑呈现明显的两极分化，即推荐类和反感类相关内容的DB值占比都处于高位，
              分别为<span className={s.emphasis}>48.02%</span>、<span className={s.emphasis}>46.46%</span>。
            </li>
            <li contentEditable>
              公司品牌中，推荐类和好感类的内容条数最多，数字品牌价值占比最高，二者合计占<span className={s.emphasis}>98.49%</span>。
            </li>
            <li contentEditable>
              产品品牌中，推荐类的内容条数最多，为<span className={s.emphasis}>31,017</span>条；
              数字品牌价值占比也为最高，为<span className={s.emphasis}>88.09%</span>，表明全年传播效果良好，公众对小罐茶的产品高度认可。
            </li>
          </ul>
          <div className={s.chartWrapper}>
            <div className={s.chart}>
              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>
            <div className={s.bottom}>
              <div className={s.bottomDes}>
                注：红色字体为数字品牌价值占比，公式为：某情感倾向的DB值/该品牌方向五级情感倾向DB值绝对值之和。
              </div>
              <div className={s.bottomLeg}>
                <DBTable
                  columns={this.fillColor(tableColumns)}
                  data={tableList}
                  style={{ boxShadow: 'none' }}
                />
              </div>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P6);



// WEBPACK FOOTER //
// src/routes/visualChart/P6/index.js